import React from 'react';

class RowItemKetQuaThanhTraTaiChinhNganHang extends React.Component {

  render() {
    let Item = this.props.item;
    let data = Item ? Item.soLieuBaoCaoInfo : {};
    return (
      <tr className={this.props.sum ? 'txt-bold' : ''}>
        <td className='column-stt-fixed'>{this.props.count}</td>
        <td className='column-name-fixed'>{data.tenDonVi}</td>

        <td className='txt-center'>{data.tongSoCuocThanhTra}</td>
        <td className='txt-center'>{data.kyTruocChuyenSang}</td>
        <td className='txt-center'>{data.trienKhaiTrongKyBaoCao}</td>
        <td className='txt-center'>{data.theoKeHoach}</td>
        <td className='txt-center'>{data.dotXuat}</td>
        <td className='txt-center'>{data.ketThucThanhTraTrucTiep}</td>
        <td className='txt-center'>{data.daBanHanhKetLuan}</td>
        <td className='txt-center'>{data.soDonViDuocThanhTra}</td>
        <td className='txt-center'>{data.soDonViCoViPham}</td>
        <td className='txt-center'>{data.soTienViPham}</td>
        <td className='txt-center'>{data.soTienKienNghiThuHoi}</td>
        <td className='txt-center'>{data.kienNghiKhac}</td>
        <td className='txt-center'>{data.kienNghiXLHanhChinhToChuc}</td>
        <td className='txt-center'>{data.kienNghiXLHanhChinhCaNhan}</td>
        <td className='txt-center'>{data.kienNghiXuLyVu}</td>
        <td className='txt-center'>{data.kienNghiXuLyDoiTuong}</td>
        <td className='txt-center'>{data.soTienDaThu}</td>
        <td className='txt-center'>{data.tongSoKLTTVaQDXLDaKTDD}</td>
        <td className='txt-center'>{data.kiemTraDonDocTienPhaiThu}</td>
        <td className='txt-center'>{data.kiemTraDonDocTienDaThu}</td>
        <td className='txt-center'>{data.ketQuaKiemTraDonDocDaXuLyHCToChuc}</td>
        <td className='txt-center'>{data.ketQuaKiemTraDonDocDaXuLyHCCaNhan}</td>
        <td className='txt-center'>{data.ketQuaKiemTraDonDocDaKhoiToVu}</td>
        <td className='txt-center'>{data.ketQuaKiemTraDonDocDaKhoiToDoiTuong}</td>        
        <td className='ghi-chu'>{data.ghiChu}</td>
      </tr>
    );
  }
}

export default RowItemKetQuaThanhTraTaiChinhNganHang;


// WEBPACK FOOTER //
// ./src/components/modules/bao-cao-tong-hop/datatable/RowItemKetQuaThanhTraTaiChinhNganHang.jsx